module.exports = __webpack_public_path__ + "static/media/HSP70_distance_matrix.e96bec7b.csv";